import React, { useState } from "react"
import FileUpload from './file_upload';

export default function IngestionForm({url}) {
  const [files, setFiles] = useState(null);

  const filePresent = files && files.length > 0;
  const csrfToken = globalThis.document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  return (
    <form id="new_ingestion" action={url} method="post" encType="multipart/form-data" className="w-full">
      <input type="hidden" name="authenticity_token" value={csrfToken} autoComplete="off" />
      <div className="space-y-8">
        <div>
          <FileUpload
            htmlId="ingestion_files"
            htmlName="files[]"
            multiple={true}
            className="min-h-40 flex items-center justify-center text-center text-wrap"
            onChange={(files) => setFiles(files)}
          />
          <p className="text-gray-500 text-sm mt-2">
            Drop in any mix of booklets, renewals, or claims documents — no need to pick a group or
            document type first. We'll sort them out.
          </p>
        </div>
        <div>
          <input
            type="submit"
            name="commit"
            value="Upload and start"
            className={"button button__primary" + (filePresent ? "" : " button__disabled")}
            disabled={filePresent ? null : "disabled"}
          />
        </div>
      </div>
    </form>
  )
}
